import { Tooltip } from "@material-ui/core";
import React, { cloneElement } from "react";
import { Permission } from "../../../constants/PERMISSIONS";
import { useGetRoles } from "../../../hooks/useGetRole";
import { isPermissionGranted } from "../../../utilities/permissionUtils";

export interface IPermissionGateProps {
    children: React.ReactElement;
    scope: Permission | Permission[];
    disabled?: boolean;
    tooltip?: string;
}

const PermissionGuard: React.FunctionComponent<IPermissionGateProps> = (props: IPermissionGateProps) => {
    const roles = useGetRoles();
    const { children, scope, disabled, tooltip } = props;
    const permissionGranted = isPermissionGranted(roles, scope);
    if (!permissionGranted && disabled) {
        const newElement = cloneElement(children, { disabled: true });
        return tooltip ? (
            <span>
                <Tooltip title={tooltip}>{newElement}</Tooltip>
            </span>
        ) : (
            newElement
        );
    }

    return !permissionGranted ? null : <>{children}</>;
};

export default PermissionGuard;
